module.exports = __webpack_public_path__ + "img/dutyfree_hover_6494eda.png";